import * as React from "react"
const UpGraph = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={ 30 }
        height={ 23 }
        fill="none"
        { ...props }
    >
        <path
            fill="#05B805"
            d="m29.997 1.275-.584 6.884c-.067.756-.823 1.081-1.256.55l-1.378-1.69-8.673 10.634a1.296 1.296 0 0 1-2.046 0l-4.777-5.856-8.071 9.9c-.28.343-.65.52-1.021.52-.371 0-.742-.177-1.02-.519a2 2 0 0 1-.423-1.255c0-.47.152-.921.422-1.254l9.091-11.147c.545-.668 1.503-.668 2.043 0l4.781 5.857 7.652-9.382-1.613-1.978c-.438-.538-.173-1.464.444-1.541l5.614-.715a.61.61 0 0 1 .324.045.734.734 0 0 1 .276.213.95.95 0 0 1 .175.337c.037.127.05.263.04.397Z"
        />
    </svg>
)

export default UpGraph